export default "__VITE_ASSET__kWq$349W__"